export default [
  {
    path: '/fish-types',
    name: 'fish-types',
    component: () => import('@/views/pages/fish-type/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-types',
      resource: 'fish_type',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fish-types/add',
    name: 'add-fish-type',
    component: () => import('@/views/pages/fish-type/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-types',
      resource: 'fish_type',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/fish-types',
          active: false,
        },
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fish-types/modify/:id',
    name: 'modify-fish-type',
    component: () => import('@/views/pages/fish-type/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-types',
      resource: 'fish_type',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/fish-types',
          active: false,
        },
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
